import { z } from 'zod';
import * as s from './shared';

const equipmentTypeSchema = s.wpOptionEntrySchema.extend({
  equipmentType: z.array(z.number()),
  boatmodel: z.array(z.number()),
  acf: z.object({
    position: s.coordinatesSchema,
    target: s.coordinatesSchema,
    camera_postion_object: z.string(),
    requires: z.union([z.string(), z.array(z.number())]), // The string is always empty/falsy, and is used instead of an empty array.
    superlight_carbon_compatible: z.boolean(),
    display_name: z.string(),
    text: z.string(),
    image: s.wpImageSchema,
    price: z.union([z.string(), z.number()]),
    price_eur: z.union([z.string(), z.number()]),
    price_sek: z.union([z.string(), z.number()]),
    price_usd: z.union([z.string(), z.number()]),
    speed_penalty: z.string(),
    label: z.string(),
    shapediver_property_id: z.string(),
    shapediver_option_id: z.string(),
  }),
  prices: s.pricesSchema,
  _embedded: z.object({
    'wp:term': z.array(
      z.array(
        z.object({
          id: z.number(),
          name: z.string(),
          slug: z.string(),
          taxonomy: z.string(),
          acf: z.union([
            z.tuple([]), // When the ACF object is empty, it serializes to an empty [] instead of an object.
            z.object({
              thumbnail: s.wpImageSchema,
            }),
          ]),
        })
      )
    ),
  }),
});

export type EquipmentOption = z.infer<typeof equipmentTypeSchema>;

export default z.array(equipmentTypeSchema);
